import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-246f8cdf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "booklet" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-246f8cdf><div class=\"top-line\" data-v-246f8cdf><h1 class=\"title\" data-v-246f8cdf> Check Out Our <span class=\"color\" data-v-246f8cdf>Booklet</span></h1><p class=\"title-text\" data-v-246f8cdf> Or save the file to your device - Alternate file (~45MB) <a href=\"./Aardvark_Booklet_2024.pdf\" target=\"_blank\" class=\"color\" data-v-246f8cdf>Download</a></p></div><hr data-v-246f8cdf></div>", 1)
const _hoisted_3 = { class: "container brochure" }
const _hoisted_4 = ["srcset", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(16, (i) => {
        return _createElementVNode("img", {
          key: i,
          srcset: `./brochure-2024/${i}.jpg`,
          alt: `Brochure page ${i}`
        }, null, 8, _hoisted_4)
      }), 64))
    ])
  ]))
}